import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { ConfirmationStoreType } from '@/types/storeTypes/confirmationStoreType'

// TODO refactor: useConfirmationStore -> common store declaration
const useConfirmationStore = create<ConfirmationStoreType>()(
  devtools(
    immer((set, get) => ({
      popup: null,
      confirm: (options) => {
        set(
          (state) => {
            state.popup = { ...options }
          },
          false,
          'confirm',
        )
      },
      onSubmit: async () => {
        await get().popup?.onSubmit()
        set((state) => {
          state.popup = null
        })
      },
      onCancel: () => {
        get().popup?.onCancel?.()
        set((state) => {
          state.popup = null
        })
      },
    })),
    { name: 'store2' },
  ),
)

export default useConfirmationStore
